<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 日次入退場状況詳細：閲覧の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>日次入退場状況詳細：閲覧の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/entrance-exit-transit-daily-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> イベント
        </div>
        <div class="manual-explain">
          イベントが表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 入場口
        </div>
        <div class="manual-explain">
          入場口ごとの通過人数が表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 退場口
        </div>
        <div class="manual-explain">
          退場口ごとの通過人数が表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 来場日
        </div>
        <div class="manual-explain">
          来場日が表示されます。<br>
        </div>


        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 展示
        </div>
        <div class="manual-explain">
          展示ごとの来場人数が表示されます。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Daily Entry/Exit Status Details: View
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Daily Entry/Exit Status Details: View</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_entrance-exit-transit-daily-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Event
        </div>
        <div class="manual-explain">
          The event is displayed.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Entrance
        </div>
        <div class="manual-explain">
          The number of people passing through each entrance is displayed.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Exit
        </div>
        <div class="manual-explain">
          The number of people passing through each exit is displayed.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Visit Date
        </div>
        <div class="manual-explain">
          The visit date is displayed.<br>
        </div>


        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Exhibit
        </div>
        <div class="manual-explain">
          The number of visitors to each exhibit is displayed.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
